/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisplayName
 */
export interface DisplayName {
    /**
     * 
     * @type {string}
     * @memberof DisplayName
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DisplayName
     */
    languageCode?: string | null;
}

/**
 * Check if a given object implements the DisplayName interface.
 */
export function instanceOfDisplayName(value: object): value is DisplayName {
    return true;
}

export function DisplayNameFromJSON(json: any): DisplayName {
    return DisplayNameFromJSONTyped(json, false);
}

export function DisplayNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayName {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'] == null ? undefined : json['text'],
        'languageCode': json['languageCode'] == null ? undefined : json['languageCode'],
    };
}

export function DisplayNameToJSON(json: any): DisplayName {
    return DisplayNameToJSONTyped(json, false);
}

export function DisplayNameToJSONTyped(value?: DisplayName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'languageCode': value['languageCode'],
    };
}

